import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  getModalInfoByOwner,
  getFullPath
} from './../reducers';
import { modal as modalActions } from './../actions';
import { owners } from './../helpers/modals';

import FailedTestArtifactsComponent from './../Components/FailedTestArtifactsComponent';

export const mapStateToProps = (state) => {
  const modalInfo = getModalInfoByOwner(state, owners.testArtifacts);
  const fullPath = getFullPath(state);
  return {
    detailsVisible: modalInfo.detailsVisible,
    fullPath: fullPath
  };
};

export const mapDispatchToProps = (dispatch) => ({
  onExpandClick: (detailsVisible, item, fullPath) => {
    const isVisible = detailsVisible[item] ? true : false;
    if (!isVisible)
    {
      if (fullPath.indexOf('&dv=') === -1)
        dispatch(push(fullPath + '&dv=' + item));
      else
        dispatch(push(
          fullPath + '+' + item
        ));
    }
    else
    {
      let begin;
      let endIndex;
      let after;
      if (Object.values(detailsVisible).reduce((total, curr) => {
        return curr ? total + 1 : total;
      }, 0) > 1)
      {
        begin = fullPath.substring(0, fullPath.indexOf(item));
        endIndex = fullPath.substring(fullPath.indexOf(item) + 1).indexOf('+');
        after = endIndex !== -1 ? fullPath.substring(endIndex + begin.length + 2) : '';
        if (after === '' && begin.charAt(begin.length - 1) === '+')
          begin = begin.substring(0, begin.length - 1);
      }
      else
      {
        begin = fullPath.split('&dv=')[0];
        after = '';
      }
      dispatch(push(begin + after));
    }
    dispatch(modalActions.toggleTestArtifactsDetails({
      ...detailsVisible,
      [item]: !isVisible
    }));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FailedTestArtifactsComponent);


// WEBPACK FOOTER //
// src/Containers/FailedTestArtifactsContainer.jsx